/**
 * configurationsreducer.js
 * Created by calhosh on 8/27/2020.
 */
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function ConfigurationsReducer(state = initialState.configurations, action) {
	switch (action.type) {
		case types.GET_CONFIGURATIONS: {
			return action.response;
		}
		default:
			return state;
	}
}
